export const theme = {
  fonts: {
    logoFont: "'Passion One', cursive",
    displayFont: "'Oswald', sans-serif",
    mainFont: "'Lato', sans-serif",
  },
  colors: {
    mainBackground: "#333333",
    main: "#171717",
    secondary: "#FFFFFF",
    text1: "#707070",
    text2: "#949494",
    postMessage: "#B7B7B7",
    inputBackground: "#EFEFEF",
    buttonBackground: "#1877F2",
    likeButton: "#AC0000",
    placeholder: "#9F9F9F",
    linkPreviewBorder: "#4D4D4D",
    linkPreviewTitle: "#CECECE",
    linkPreviewDescription: "#9B9595",
    error: "#ff3b1f",
    tooltipText: "#505050",
    search: "#C6C6C6",
    searchResults: "#E7E7E7",
    searchResultName: "#515151",
    disabledButton: "#9B9595",
    repostBackground: "#1E1E1E",
    followingText: "#C5C5C5",
  },
  spacing: {
    maxBodyWidth: "1024px",
    headerHeight: "72px",
  },
  breakPoints: {
    mobile: "320px",
    tablet: "481px",
    laptop: "769px",
    largeScreen: "1024px",
    desktop: "1279px",
  },
  borderRadius: {
    post: "16px",
  },
}
